import { Button } from '@healingpaper/cell'
import { Icon, IconPack } from '@healingpaper/cell'
import sanitize from 'sanitize-html'
import styled from 'styled-components'

import { ResponsiveSizeV2 } from '@/components/atomic/_enums'
import Text from '@/components/atomic/atoms/Text'
import { getDownloadLink, postAmplitude, postGtag } from '@/core/lib'
import theme from '@/theme'
import { sendAirbridgeEvent, AirbridgeEvents } from '@/utils/airbridge'

export interface Props {
  description: string
  downloadText: string
  onClickClose: () => void
}

const MobileTopDownloadBanner = ({ description, downloadText, onClickClose }: Props): JSX.Element => {
  const handleClickDownload = async () => {
    const url = getDownloadLink()
    sendAirbridgeEvent(AirbridgeEvents.APP_DOWNLOAD_BUTTON_CLICK, { semanticAttributes: {} })
    postGtag('click_download')

    // legacy. 추후 click_download로 통합합니다. _modn
    postAmplitude('click_header_download', {
      path: `${location.pathname}${location.search}`,
      referrer: document.referrer,
    })
    postAmplitude('click_download', {
      button_position: 'top-banner',
    })
    window.open(url, '_blank')
  }

  return (
    <Container>
      <LeftContent>
        <StyledCloseButton aria-label="Close banner" onClick={() => onClickClose()}>
          <Icon name={IconPack.GENERAL_ACTION_EXIT_BLACK} width={20} height={20} />
        </StyledCloseButton>
        <StyledTitle type="caption2" element="h3" numberOfLines={2}>
          <span dangerouslySetInnerHTML={{ __html: sanitize(description, { allowedTags: ['strong', 'br'] }) }} />
        </StyledTitle>
      </LeftContent>
      <DownloadButton size="Small" hierarchy="Primary" onClick={handleClickDownload}>
        <Text type="caption1" element="span" color="white">
          {downloadText}
        </Text>
      </DownloadButton>
    </Container>
  )
}

const Container = styled.div`
  height: ${theme.variables.topDownloadBannerHeight}px;
  background-color: ${({ theme }) => theme.colors.lightOrange};
  display: flex;
  justify-content: space-between;
  padding: 16px 8px;
  box-sizing: border-box;
  align-items: center;

  @media screen and (min-width: ${ResponsiveSizeV2.DESKTOP_MIN_WIDTH}px) {
    display: none;
  }
`

const LeftContent = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
`

const StyledCloseButton = styled.button`
  border: none;
  background-color: transparent;
  padding: 0px;
  line-height: 0;
  cursor: pointer;
`

const DownloadButton = styled(Button)`
  border-radius: 16px !important;
  padding: 0px 6px;
  * {
    ${({ theme }) => theme.typography.title4}
    line-height: 16px;
    color: ${({ theme }) => theme.colors.white};
  }
`

const StyledTitle = styled(Text)`
  flex: 1;
  color: ${({ theme }) => theme.colors.gray900};
  font-weight: 700;
  ${({ theme }) => theme.typography.title4}
  strong {
    color: ${({ theme }) => theme.colors.orange};
  }
`

export default MobileTopDownloadBanner
